import type { CreateBriefData } from '../hooks/use-briefs'

function splitList(value: string | undefined): string[] {
  if (!value?.trim()) return []
  return value
    .split(/[,;\n]/)
    .map((part) => part.trim())
    .filter(Boolean)
}

function joinPresent(parts: Array<string | undefined>): string | undefined {
  const filled = parts.map((part) => part?.trim()).filter(Boolean) as string[]
  return filled.length > 0 ? filled.join('\n\n') : undefined
}

/** Map a pack structured brief onto the product `CreateBriefData` contract. */
export function structuredBriefToCreateData(
  fields: Record<string, string>,
): CreateBriefData {
  const title = fields.title?.trim() || 'Untitled brief'
  const location = [fields.location, fields.work_mode]
    .map((part) => part?.trim())
    .filter(Boolean)
    .join(' · ')
  const required = splitList(fields.must_have_skills)
  const preferred = splitList(fields.nice_to_have_skills)
  const description = joinPresent([
    fields.responsibilities,
    fields.outcomes ? `Success in 90 days:\n${fields.outcomes}` : undefined,
    fields.team ? `Team: ${fields.team}` : undefined,
    fields.seniority ? `Seniority: ${fields.seniority}` : undefined,
    fields.employment_type ? `Employment: ${fields.employment_type}` : undefined,
    fields.reporting_line ? `Reports to: ${fields.reporting_line}` : undefined,
    fields.compensation ? `Compensation: ${fields.compensation}` : undefined,
    fields.timeline ? `Timeline: ${fields.timeline}` : undefined,
  ])
  const instructions = joinPresent([fields.constraints, fields.notes])

  return {
    title,
    location: location || undefined,
    description,
    instructions,
    required_skills: required.length > 0 ? required : undefined,
    preferred_skills: preferred.length > 0 ? preferred : undefined,
    status: 'draft',
  }
}
